


























































































































































































































import { EventData, FeatureMap } from "../models/FeatureMap";
import FooterBar from "./menu/FooterBar.vue";
import ReaderSettings from "./menu/ReaderSettingsMenu.vue";

import colors from "vuetify/lib/util/colors";
import {
  DeviceInfoResponseLike,
  SettingsMessage,
} from "@thales-dis-dr/drmcl-ts-shared";
import { WebApiModule } from "@/models/WebApiModule";
import { Route } from "vue-router";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
const webapi = namespace("webapi");

interface PageNav {
  to: string;
  title: string;
  icon: string;
}

@Component({
  components: {
    FooterBar,
    ReaderSettings,
  },
})
export default class AppLayout extends Vue {
  @Prop({ type: String })
  readonly source!: string;

  @webapi.Getter("session")
  readonly webApiSession!: WebApiModule | null;

  @webapi.Getter("deviceInfo")
  readonly deviceInfo!: DeviceInfoResponseLike;
  pages: PageNav[] = [
    //{ to: "/session/dash", title: "Dash", icon: "mdi-view-dashboard" },
    { to: "/session/capture", title: "Capture", icon: "mdi-camera-iris" },
    {
      to: "/session/details",
      title: "Device Details",
      icon: "mdi-information-outline",
    },
    {
      to: "/session/config",
      title: "Configuration",
      icon: "mdi-tune-vertical-variant",
    },
  ];

  // drawer state
  drawerRight = false;
  drawerLeft = false;
  readerSettingsVisibility = false;
  right = false;
  readerEvents = false;
  applicationSettings = false;
  left = false;

  @webapi.Getter("events")
  readonly readerevents!: EventData[];

  @webapi.Getter("errors")
  readonly readerErrors!: EventData[];

  faceMatch = false;
  saveJWT = false;
  twoSidedDocuments = false;
  acuant = false;
  darkMode = false;
  popupEvents = false;
  useBackground = false;
  primarySelect = "";
  colorOptions = Object.keys(colors);

  @webapi.Action
  public getReaderSettings!: () => SettingsMessage | null;

  @webapi.Mutation
  public clearEvents!: () => void;

  @webapi.Action
  public closeConnection!: () => void;

  async showReaderSettings(): Promise<void> {
    await this.getReaderSettings();
    this.readerSettingsVisibility = true;
  }

  closeReaderSettings(): void {
    this.readerSettingsVisibility = false;
  }

  complete(): void {
    // no action
  }

  disconnect(): void {
    this.closeConnection();
    this.$router.push({ name: "connect" });
  }

  primarySelection(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.$vuetify.theme.themes.light.primary = (colors as any)[
      this.primarySelect
    ];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.$vuetify.theme.themes.dark.primary = (colors as any)[
      this.primarySelect
    ];
  }

  mounted(): Promise<Route> | undefined {
    if (!this.deviceInfo) {
      return this.$router.push({ name: "connect" });
    }

    if (localStorage.twoSidedDocumentSwitch) {
      this.twoSidedDocuments = JSON.parse(localStorage.twoSidedDocumentSwitch);
    }
    if (localStorage.darkModeSwitch) {
      this.darkMode = JSON.parse(localStorage.darkModeSwitch);
    }
    if (localStorage.popupEventsSwitch) {
      this.popupEvents = JSON.parse(localStorage.popupEventsSwitch);
    }
    if (localStorage.backgroundSwitch) {
      this.useBackground = JSON.parse(localStorage.backgroundSwitch);
    }
  }

  @Watch("faceMatch")
  faceMatchChanged(isOn: boolean): void {
    this.setFeatures({ Facematch: isOn });
  }

  @Watch("saveJWT")
  saveJWTChanged(isOn: boolean): void {
    this.setFeatures({ SaveJWT: isOn });
  }

  @Watch("twoSidedDocuments")
  twoSidedDocumentsChanged(isOn: boolean): void {
    localStorage.twoSidedDocumentSwitch = isOn;
  }

  @Watch("darkMode")
  darkModeChanged(isOn: boolean): void {
    this.$vuetify.theme.dark = isOn;
    localStorage.darkModeSwitch = isOn;
  }

  @Watch("popupEvents")
  popupEventsChanged(isOn: boolean): void {
    localStorage.popupEventsSwitch = isOn;
  }

  @Watch("useBackground")
  useBackgroundChanged(isOn: boolean): void {
    localStorage.backgroundSwitch = isOn;
  }

  onDisconnect(): void {
    this.$router.push({ name: "connect" });
  }
  onReconnect(): void {
    this.$router.push({ name: "connect" });
  }
  // @Watch("isConnected")
  // isConnectedChanged(newVal: boolean): void {
  //   if (newVal === false) {
  //     this.$router.push({ name: "connect" });
  //   }
  // }

  @Getter
  public features!: FeatureMap;

  @Action
  public setFeatures!: (params: Partial<FeatureMap>) => void;

  @webapi.Getter
  public readerSettings!: SettingsMessage;

  @webapi.Getter
  public isConnected!: boolean;
}
